import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuSection } from "./MenuSection";
import {
  getCategories,
  getIsProductsLoading,
  getProducts,
  getStoreId,
} from "../redux/selectors";
import {
  fetchCategories,
  fetchProducts,
} from "../redux/productsData/operations";
import { reorganizeData } from "../data/helpers";
import { RadarLoader } from "./RadarLoader";
import { toast } from "react-toastify";

export const Products = () => {
  const dispatch = useDispatch();
  const productsData = useSelector(getProducts);
  const categoriesData = useSelector(getCategories);
  const storeId = useSelector(getStoreId);
  const isProductsLoading = useSelector(getIsProductsLoading);

  const isDataLoading =
    isProductsLoading ||
    productsData.length === 0 ||
    categoriesData.length === 0;

  useEffect(() => {
    if (categoriesData.length === 0) {
      dispatch(fetchCategories());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (productsData.length === 0) {
      dispatch(fetchProducts(storeId || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchProducts(storeId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId]);

  const productsNew = productsData.length
    ? reorganizeData(productsData, categoriesData)
    : [];

  if (isDataLoading) {
    return <RadarLoader />;
  }

  return (
    <div className="relative">
      {productsNew.map((el) => (
        <MenuSection data={el} key={el.categoryId} />
      ))}
      {!storeId && (
        <div
          className="absolute top-0 left-0 w-full h-full z-10 bg-[#00000040] blur-lg"
          onClick={() => toast.info("Please select a serving area first!")}
        ></div>
      )}
    </div>
  );
};
